import {
  EpisodeCardJumboSkeleton,
  EpisodeCardLargeSkeleton,
  EpisodeCardMediumSkeleton,
  EpisodeCardSmallSkeleton,
} from './components';
import { EpisodeCardVariants } from './constants';

interface EpisodeCardSkeletonProps {
  includeText?: boolean;
  variant?: (typeof EpisodeCardVariants)[keyof typeof EpisodeCardVariants];
  stretch?: boolean;
}

export const EpisodeCardSkeleton = ({
  variant = EpisodeCardVariants.MEDIUM,
  stretch = false,
  ...props
}: EpisodeCardSkeletonProps) => {
  return {
    [EpisodeCardVariants.SMALL]: <EpisodeCardSmallSkeleton {...props} />,
    [EpisodeCardVariants.MEDIUM]: (
      <EpisodeCardMediumSkeleton stretch={stretch} {...props} />
    ),
    [EpisodeCardVariants.LARGE]: <EpisodeCardLargeSkeleton />,
    [EpisodeCardVariants.JUMBO]: <EpisodeCardJumboSkeleton />,
  }[variant];
};
